module.exports = __webpack_public_path__ + "img/check-circle-fill-green.a1ec0c17.svg";